import { TextInput, TextInputProps } from './TextInput';
export type { TextInputProps };
export default TextInput;
